import { djangoQueryClient } from "api/client/DjangoClient";
import { paths } from "api/schema/api-schema";
import {} from "@tanstack/react-query";
import assert from "assert";
import { djangoClientReactQueryFactory } from "api/client/helpers/reactQueryFactory";
import { DjangoClientMethod } from "api/client/types/DjangoClient.types";

const path = "/trs/tool/{id}/" satisfies keyof paths;
const method = "GET" satisfies DjangoClientMethod;
type ToolId = paths[typeof path]["get"]["parameters"]["path"]["id"];

const queryFn = async (toolId: ToolId) => {
  const res = await djangoQueryClient[method](path, {
    params: { path: { id: toolId } },
  });

  const tool = res.data;
  assert(tool !== undefined, "Expected tool to be defined in response");

  return tool;
};

export const toolGet = {
  queryFn,
  useQuery: djangoClientReactQueryFactory(path, method, queryFn),
};
